import { render, staticRenderFns } from "./SingleValueDisplayCard.vue?vue&type=template&id=15da16ab&scoped=true"
import script from "./SingleValueDisplayCard.vue?vue&type=script&lang=js"
export * from "./SingleValueDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./SingleValueDisplayCard.vue?vue&type=style&index=0&id=15da16ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da16ab",
  null
  
)

export default component.exports